"use client";

import { create } from "zustand";

interface SearchModeState {
	mode: "manual" | "preference";
	setMode: (mode: "manual" | "preference") => void;
	initializeFromUrl: () => void;
}

// Function to get initial mode from URL
const getInitialModeFromUrl = (): "manual" | "preference" => {
	if (typeof window === "undefined") return "manual";

	const pathname = window.location.pathname;

	// Check for preference route pattern: /preference or /city/preference
	const isPreferenceMode = pathname.includes("/preference");

	const mode = isPreferenceMode ? "preference" : "manual";

	return mode;
};

export const useSearchMode = create<SearchModeState>((set, get) => ({
	mode: getInitialModeFromUrl(),
	setMode: mode => {
		set({ mode });
	},
	initializeFromUrl: () => {
		const urlMode = getInitialModeFromUrl();
		if (get().mode !== urlMode) {
			set({ mode: urlMode });
		}
	},
}));
